/**
 * OTP Status
 * Gestione stati e utility per sidebar-otp
 */

/**
 * Canale di invio OTP
 */
export const OTP_CHANNEL = {
  MAIL: 'MAIL',
  SMS: 'SMS',
}

/**
 * Stati possibili dell'OTP
 */
export const OTP_STATUS = {
  NOT_REQUIRED: 'NOT_REQUIRED',               // OTP non necessario, nulla da fare
  REQUIRED: 'REQUIRED',                       // OTP deve essere richiesto
  OTP_SENT: 'OTP_SENT',                       // OTP inviato
  RATE_LIMITED: 'RATE_LIMITED',               // Troppe chiamate "new"
  VALID: 'VALID',                             // Inserito OTP valido, sessione autenticata
  ALREADY_VALIDATED: 'ALREADY_VALIDATED',     // Già autenticato
  NOT_VALID: 'NOT_VALID',                     // OTP non valido
  ERROR: 'ERROR',                             // Errore generico
}

/**
 * Verifica se lo stato OTP richiede l'input del codice
 * @param {string} status - Stato corrente OTP
 * @returns {boolean}
 */
export function requires_code_input(status) {
  return [
    OTP_STATUS.OTP_SENT,
    OTP_STATUS.RATE_LIMITED,
    OTP_STATUS.NOT_VALID
  ].includes(status)
}
